import { RiArrowDropDownLine } from "react-icons/ri";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaXmark } from "react-icons/fa6";
import { useState } from "react";
import { Dialog, Disclosure, Popover, Transition } from "@headlessui/react";
import { Link } from "react-router-dom";

const headerList: Array<any> = [
  {
    link: "/preview",
    name: "시설안내",
  },
  {
    link: "/information",
    name: "이용안내",
  },
];
const headerList2: Array<any> = [
  {
    link: "https://www.instagram.com/choihue_camping",
    name: "Instagram",
  },
  {
    link: "https://www.youtube.com/@user-gy3xd9ob9m",
    name: "Youtube",
  },
];

export const Header = (): JSX.Element => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  return (
    <header className="pl-2 pr-5 py-1 z-10 bg-bg text-white">
      <nav
        className="mx-auto flex items-center justify-between p-2"
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <Link to={`/`}>
            <img className="w-24 sm:w-36" src="/logo.png" alt="logo" />
          </Link>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-white"
            onClick={() => setMenuOpen(true)}
          >
            <GiHamburgerMenu size={22} />
          </button>
        </div>

        <div className="hidden lg:flex lg:gap-x-10">
          <div className="relative  group text-base font-semibold">
            <button className=" text-site bg-transparent  focus:border-brand focus:outline-none focus:ring-0 peer flex items-center justify-between rounded">
              안내
              <RiArrowDropDownLine size={24} />
            </button>
            <div className="bg-bg border-bg absolute z-[99] top-[100%] left-[50%] translate-x-[-50%] rounded-md overflow-hidden shadow-lg min-w-[100px] w-max peer-focus:visible peer-focus:opacity-100 opacity-0 invisible duration-200 p-1 bg-gray-100 border border-dimmed text-xs md:text-sm">
              {headerList.map((item: any, index: number) => (
                <Link key={index} to={`${item.link}`}>
                  <li
                    key={index}
                    className={`w-full block cursor-pointer hover:bg-point hover:text-link hover:text-white px-3 py-2 rounded-md`}
                  >
                    {item.name}
                  </li>
                </Link>
              ))}
            </div>
          </div>

          <Link
            className={`text-white hover:text-point text-base font-semibold`}
            to={`/location`}
          >
            오시는길
          </Link>
          <a
            className={`text-white hover:text-point text-base font-semibold`}
            href="https://camfit.co.kr/camp/6540605cb62e45001e520e2e"
          >
            예약하기
          </a>
          <Link
            className={`text-white hover:text-point text-base font-semibold`}
            to={`/travel`}
          >
            여행지
          </Link>
          <Link
            className={`text-white hover:text-point text-base font-semibold`}
            to={`/gallery`}
          >
            갤러리
          </Link>
          <div className="relative  group text-base font-semibold">
            <button className=" text-site bg-transparent  focus:border-brand focus:outline-none focus:ring-0 peer flex items-center justify-between rounded">
              SNS
              <RiArrowDropDownLine size={24} />
            </button>
            <div className="bg-bg border-bg absolute z-[99] top-[100%] left-[50%] translate-x-[-50%] rounded-md overflow-hidden shadow-lg min-w-[100px] w-max peer-focus:visible peer-focus:opacity-100 opacity-0 invisible duration-200 p-1 bg-gray-100 border border-dimmed text-xs md:text-sm">
              {headerList2.map((item: any, index: number) => (
                <a key={index} href={`${item.link}`}>
                  <li
                    key={index}
                    className={`w-full block cursor-pointer hover:bg-point hover:text-link hover:text-white px-3 py-2 rounded-md`}
                  >
                    {item.name}
                  </li>
                </a>
              ))}
            </div>
          </div>
        </div>
      </nav>
      <Dialog
        as="div"
        className="lg:hidden"
        open={menuOpen}
        onClose={setMenuOpen}
      >
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className=" sm:ring-bg fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-bg border-bg px-6 py-4 sm:max-w-xs sm:ring-1 sm:ring-gray2">
          <div className="flex items-center justify-between">
            <button className="-m-1.5 p-1.5">
              <Link to={`/`}>
                <img className="w-24 sm:w-36" src="/logo.png" alt="logo" />
              </Link>
            </button>
            <button
              type="button"
              className="absolute right-8 text-white"
              onClick={() => setMenuOpen(false)}
            >
              <FaXmark size={24} className="text-white" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y ">
              <div className="space-y-2 py-6">
                <Disclosure as="div" className="-mx-3">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-center justify-start rounded-lg py-2 px-3 text-base font-semibold leading-7 text-white">
                        안내
                        <RiArrowDropDownLine
                          size={30}
                          className="absolute right-8"
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="mt-2 space-y-2">
                        {[...headerList].map((item: any, index: number) => (
                          <Link
                            key={index}
                            to={`${item.link}`}
                            className="text-white  hover:text-point"
                            onClick={() => setMenuOpen(false)}
                          >
                            <Disclosure.Button
                              key={item + index}
                              as="button"
                              className="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 "
                            >
                              {item.name}
                            </Disclosure.Button>
                          </Link>
                        ))}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
                <Link
                  to={`/location`}
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-white  hover:text-point"
                  onClick={() => {
                    setMenuOpen(false);
                  }}
                >
                  오시는길
                </Link>
                <a
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-white  hover:text-point"
                  href="https://camfit.co.kr/camp/6540605cb62e45001e520e2e"
                >
                  예약하기
                </a>
                <Link
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-white  hover:text-point"
                  to={`/travel`}
                  onClick={() => setMenuOpen(false)}
                >
                  여행지
                </Link>{" "}
                <Link
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-white  hover:text-point"
                  to={`/gallery`}
                  onClick={() => setMenuOpen(false)}
                >
                  갤러리
                </Link>
                <Disclosure as="div" className="-mx-3">
                  {({ open }) => (
                    <>
                      <Disclosure.Button className="flex w-full items-center justify-start rounded-lg py-2 px-3 text-base font-semibold leading-7 text-white">
                        SNS
                        <RiArrowDropDownLine
                          size={30}
                          className="absolute right-8"
                        />
                      </Disclosure.Button>
                      <Disclosure.Panel className="mt-2 space-y-2">
                        {[...headerList2].map((item: any, index: number) => (
                          <a
                            key={index}
                            href={`${item.link}`}
                            className="text-white  hover:text-point "
                          >
                            <Disclosure.Button
                              key={item + index}
                              as="button"
                              className="block rounded-lg py-2 pl-6 pr-3 text-sm font-semibold leading-7 "
                            >
                              {item.name}
                            </Disclosure.Button>
                          </a>
                        ))}
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  );
};
